import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
// import { crearCategoria, modificarCategoria } from "../../../api/api-categoria";
// import cargandoCard from "../../../components/cargando-card";
// import { obtenerListaCategoria } from "../../../api/api-categoria";
import Select from "react-select";
// import { actualizarProducto, crearProducto } from "../../../api/api-producto";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { actualizarEstado, crearEstado } from "../../../api/api-estado";
import { obtenerListaFormulario } from "../../../api/api-formulario";
import SwitchComponent from "../../../components/switch";
import { obtenerListaPersona } from "../../../api/api-persona";

export default function EstadoPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [listaFormularios, setListaFormularios] = useState([]);
  const [formularioSelected, setFormularioSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [finalizarProceso, setFinalizarProceso] = useState(false);
  const [pedirDetalleProductos, setPedirDetalleProductos] = useState(false);

  const [listaPersonas, setListaPersonas] = useState([]);
  const [personasSelected, setPersonasSelected] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      const formularios = await obtenerListaFormulario({ habilitado: 1 }, true);
      setListaFormularios(formularios);
      if (data.params.idFormulario !== undefined && data.params.idFormulario !== null) {
        const formulario = formularios.find((item) => item.value === data.params.idFormulario);
        setFormularioSelected(formulario);
      }
      if (data.params.finalizarProceso !== undefined && data.params.finalizarProceso !== null) {
        setFinalizarProceso(data.params.finalizarProceso);
      }
      if (data.params.pedirDetalleProductos !== undefined && data.params.pedirDetalleProductos !== null) {
        setPedirDetalleProductos(data.params.pedirDetalleProductos);
      }


      const personas = await obtenerListaPersona({ habilitado: 1 }, true);
      setListaPersonas(personas);
      if (data.params.notificarA !== undefined && data.params.notificarA !== null) {
        setPersonasSelected(JSON.parse(data.params.notificarA));
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    // objEnviar.idCategoria = categoriaSelected !== null ? categoriaSelected.value : null;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.color = formData.color;
    objEnviar.idFormulario = formularioSelected !== null ? formularioSelected.value : null;
    objEnviar.finalizarProceso = finalizarProceso;
    objEnviar.pedirDetalleProductos = pedirDetalleProductos;
    objEnviar.notificarA = personasSelected;
    setProcessingVisible(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await crearEstado(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarEstado(objEnviar);
      setProcessingVisible(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  const handleColorChange = (e) => {
    let { value } = e.target;

    // Allow empty string
    if (value === '') {
      setFormData({
        ...formData,
        color: value,
      });
      return;
    }

    // If it doesn't start with #, add it automatically
    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    // Allow "#" followed by 0-6 hex characters (allows partial input while typing)
    const hexPart = value.substring(1);
    if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && value.length <= 7) {
      setFormData({
        ...formData,
        color: value.toUpperCase(),
      });
    }
  };

  const handleColorPickerChange = (e) => {
    const { value } = e.target;
    // Color picker always returns valid hex format
    setFormData({
      ...formData,
      color: value.toUpperCase(),
    });
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="color"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_color")}
                </label>
                <div className="flex flex-row items-center gap-2 mt-1">
                  <input
                    id="color"
                    name="color"
                    type="text"
                    value={formData.color || '#000000'}
                    onChange={handleColorChange}
                    className={`${ESTILO_INPUT_GENERICO} flex-1 min-w-0`}
                    placeholder="#FF00FF"
                    maxLength={7}
                  />
                  <input
                    type="color"
                    value={formData.color || '#000000'}
                    onChange={handleColorPickerChange}
                    className="h-10 w-16 shrink-0 cursor-pointer border border-gray-300 rounded"
                    title={t("label_seleccionar_color")}
                  />
                </div>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="formulario">
                  {t("label_formulario")}
                </label>
                <Select
                  options={listaFormularios}
                  isSearchable={true}
                  isClearable={true}
                  value={formularioSelected}
                  onChange={(event) => setFormularioSelected(event)}
                  placeholder={t("placeholder_seleccione_formulario")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="label_finalizar_proceso">
                  {t("label_finalizar_proceso")}?
                </label>
                <SwitchComponent
                  checked={finalizarProceso}
                  onChange={(event) => setFinalizarProceso(event)}
                />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 mt-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="label_pedir_detalles_productos">
                  {t("label_pedir_detalles_productos")}?
                </label>
                <SwitchComponent
                  checked={pedirDetalleProductos}
                  onChange={(event) => setPedirDetalleProductos(event)}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="personas">
                  {t("label_notificar_a")}
                </label>
                <Select options={listaPersonas}
                  isMulti={true}
                  isSearchable={true}
                  isClearable={true}
                  value={personasSelected}
                  onChange={(option) => setPersonasSelected(option)}
                  placeholder={t("placeholder_seleccione_persona")}
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999 }),
                    menu: (base) => ({ ...base, zIndex: 999 }),
                  }}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div >
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
